import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

/**
 * Subtle keyboard-shortcut hint inside a button (sprint 9). Hidden from assistive tech (the button's
 * `aria-keyshortcuts` carries it, and accessible names stay unchanged) and below lg, where the layout
 * is touch-first.
 */
export function Kbd({ children, className }: { children: ReactNode; className?: string }): JSX.Element {
  return (
    <kbd
      aria-hidden="true"
      className={cn(
        'pointer-events-none hidden min-w-[1.25rem] rounded border border-current px-1 text-center font-sans text-[10px] leading-4 opacity-50 lg:inline-block',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
